export default __webpack_public_path__ + "assets/images/5d8101bdd842ee12101f1b64d655d381.jpg";